export class SuccessfulTransaction {
  constructor (paymentDate, cardLast, cardBrand, msisdn, pix) {
    this.paymentDate = paymentDate
    this.cardLast = cardLast
    this.cardBrand = cardBrand
    this.msisdn = msisdn
    this.pix = pix
  }
}
